export class AppUtils {
    public static isPhoneOrTablet(): boolean {
        return window.matchMedia('(max-width: 1064px)').matches;
    }

    public static isAndroid(): boolean {
        let ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
    }
}